import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PlanLabel = ({ label = '', highlighted = false }) => {
  const classes = classNames('ws-ui-plan-label', {
    'ws-ui-plan-label--highlighted': highlighted,
  });

  if (!label) return null;
  return <div className={classes}>{label}</div>;
};

PlanLabel.propTypes = {
  label: PropTypes.string,
  highlighted: PropTypes.bool,
};

export default PlanLabel;
